/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailedPackage
 */
export interface FailedPackage {
    /**
     * 
     * @type {number}
     * @memberof FailedPackage
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FailedPackage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPackage
     */
    specifier?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPackage
     */
    source: FailedPackageSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof FailedPackage
     */
    channel?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPackage
     */
    condaName?: string;
}


/**
 * @export
 */
export const FailedPackageSourceEnum = {
    Conda: 'conda',
    Pip: 'pip'
} as const;
export type FailedPackageSourceEnum = typeof FailedPackageSourceEnum[keyof typeof FailedPackageSourceEnum];


/**
 * Check if a given object implements the FailedPackage interface.
 */
export function instanceOfFailedPackage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function FailedPackageFromJSON(json: any): FailedPackage {
    return FailedPackageFromJSONTyped(json, false);
}

export function FailedPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailedPackage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'specifier': !exists(json, 'specifier') ? undefined : json['specifier'],
        'source': json['source'],
        'channel': !exists(json, 'channel') ? undefined : json['channel'],
        'condaName': !exists(json, 'conda_name') ? undefined : json['conda_name'],
    };
}

export function FailedPackageToJSON(value?: FailedPackage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'specifier': value.specifier,
        'source': value.source,
        'channel': value.channel,
        'conda_name': value.condaName,
    };
}

